module.exports = "https://la-static.vkplay.ru/promo/universal/img/card3.12d58083.jpg";